<template>
  <section
    class="bindGoogle"
    :style="{
      marginTop: googleIsOpen === '1' ? '-49px' : '-17px',
      paddingBottom: googleIsOpen === '1' ? '6px' : '0px',
    }"
  >
    <!-- <header class="bindGoogle-header">绑定谷歌验证</header> -->
    <!-- 1 -->
    <div class="even-box" v-if="googleIsOpen === '0'">
      <div class="even">
        <div class="even-title">
          <span class="even-title-page">1</span>
          <!-- 下载谷歌验证器APP -->
          {{ $t("header.google.title1") }}
        </div>
        <!-- iOS用户登录App Store搜索“Authenticator”下载。安卓用户登录应用商店或使用手机浏览器搜索“谷歌验证器”下载。 -->
        <div class="even-text">{{ $t("header.google.mess1") }}</div>
        <div class="clearfix" style="margin-top: 15px">
          <div
            class="even-link"
            @click="
              link(
                'https://apps.apple.com/us/app/google-authenticator/id388497605'
              )
            "
          >
            <svg class="icon icon-20" aria-hidden="true">
              <use xlink:href="#icon-v4_4"></use>
            </svg>
            <span style="margin-left: 1px"> App Store</span>
          </div>
          <div
            class="even-link"
            style="margin-left: 20px"
            @click="
              link(
                'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2'
              )
            "
          >
            <svg class="icon icon-18" aria-hidden="true">
              <use xlink:href="#icon-v4_gg"></use>
            </svg>
            <span style="margin-left: 2px"> Google Play </span>
          </div>
        </div>
        <div class="clearfix" style="margin-top: 20px">
          <div
            class="even-link"
            @click="
              link(
                'https://sj.qq.com/myapp/detail.htm?apkName=com.google.android.apps.authenticator2'
              )
            "
          >
            <svg class="icon icon-20" aria-hidden="true">
              <use xlink:href="#icon-v4_az"></use>
            </svg>
            <span style="margin-left: 1px"> Android </span>
          </div>
        </div>
      </div>
    </div>
    <!-- 2 -->
    <div class="even-box" v-if="googleIsOpen === '0'">
      <div class="even">
        <div class="even-title">
          <span class="even-title-page">2</span>
          <!-- 使用谷歌身份验证器扫描二维码或手动输入密钥 -->
          {{ $t("header.google.title2") }}
        </div>
        <!-- 打开谷歌验证器，扫描下方二维码或手动输入下述密钥添加验证令牌 -->
        <div class="even-text">{{ $t("header.google.mess2") }}</div>
        <div class="clearfix" style="margin-top: 20px">
          <img :src="googleImg" alt class="QAIMG" />
          <div class="QAtext">
            {{ googleKey }}
            <input
              type="text"
              :value="googleKey"
              ref="copyInput"
              class="copyInput"
            />
            <span class="QAtext-copy" id="copyBtn" @click="copy">
              <!-- 复制 -->
              <svg class="icon active-icon" aria-hidden="true">
                <use xlink:href="#icon-v4_copy"></use>
              </svg>
            </span>
          </div>
        </div>
      </div>
    </div>
    <!-- 3 -->
    <div class="even-box" style="padding-bottom: 20px">
      <div class="even">
        <div class="even-title" v-if="googleIsOpen === '0'">
          <span class="even-title-page">3</span>
          <!-- 完成绑定 -->
          {{ $t("header.google.title3") }}
        </div>
        <!-- 密钥用于手机更换或遗失时找回谷歌验证器，绑定前请务必将下述密钥备份保存。 -->
        <div
          class="even-text"
          style="color: #faad14"
          v-if="googleIsOpen === '0'"
        >
          <img class="even-text-jg" src="../assets/images/v4_jg.svg" alt="" />
          {{ $t("header.google.mess3") }}
        </div>
        <div class="setpass-input-box">
          <!-- 手机验证码 -->
          <!-- <label><i class="text-danger"></i>{{ $t('header.google.phone')}}</label> -->
          <b-form-input
            type="text"
            v-model="sms"
            class="passwordInput"
            :state="smsShowError"
            maxLength="6"
            :placeholder="$t('header.google.phone')"
          >
          </b-form-input>
          <div class="getCodeInput-get">
            <GetCode @getCodeClick="getCodeClick" />
          </div>
          <b-form-invalid-feedback>
            {{ $t("login.codeError") }}
          </b-form-invalid-feedback>
        </div>
        <div class="setpass-input-box">
          <!-- 谷歌验证码 -->
          <!-- <label><i class="text-danger"></i>{{ $t('header.google.google')}}</label> -->
          <b-form-input
            v-model="google"
            class="passwordInput"
            :state="googleShowError"
            maxLength="6"
            :placeholder="$t('header.google.google')"
          >
          </b-form-input>
          <b-form-invalid-feedback>
            {{ $t("login.codeError") }}
          </b-form-invalid-feedback>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import GetCode from "@/components/getCode";
import { getCookie } from "@/apis/cookie";
import { fixInput, _debounce, fixD } from "@/apis/newmethods";
export default {
  data() {
    return {
      googleImg: "",
      googleKey: "",
      sms: "",
      google: "",
      submitFlag: true,
    };
  },
  components: {
    GetCode,
  },
  mounted() {
    this.getData();
  },
  watch: {
    btnDidabled(v) {
      this.$emit("googleBtnDisable", v);
    },
    google(value) {
      this.$nextTick(() => {
        this.google = fixInput(value, 0);
      });
    },
  },
  computed: {
    googleIsOpen() {
      let num = "0";
      const { user } = this.$store.state.baseData;
      if (user) {
        num = user.googleStatus.toString();
      }
      return num;
    },
    btnDidabled() {
      let flag = true;
      if (this.smsFlag && this.googleFlag) {
        flag = false;
      }
      return flag;
    },
    reg() {
      return this.$store.state.regExp;
    },
    smsShowError() {
      if (this.sms.length) {
        if (this.smsFlag) {
          return null;
        } else {
          return false;
        }
      } else {
        return null;
      }
    },
    smsFlag() {
      return this.reg.verification.test(this.sms);
    },
    googleShowError() {
      if (this.google.length) {
        if (this.googleFlag) {
          return null;
        } else {
          return false;
        }
      } else {
        return null;
      }
    },
    googleFlag() {
      return this.reg.verification.test(this.google);
    },
  },
  methods: {
    submit() {
      if (!this.submitFlag) {
        return;
      }
      this.submitFlag = false;
      // let url = this.googleIsOpen === '0' ? 'bind_google_auth' : 'close_google_auth_submit'
      let type = this.googleIsOpen === "0" ? "1" : "2";
      this.$http({
        url: "bind_google_auth_sub",
        params: {
          googleKey: this.googleIsOpen === "0" ? this.googleKey : undefined,
          googleCode: this.google,
          smsAuthCode: this.sms,
          operateType: type,
        },
      }).then((data) => {
        this.submitFlag = true;
        if (data.code.toString() === "0") {
          this.$store.dispatch("getUser");
          this.$bus.$emit("alert", { type: "success", message: data.msg });
          this.$emit("googleClose");
          this.$bus.$off("header-googleReset");
          this.$bus.$on("header-googleReset", (status) => {
            this.reset(status);
          });
          // this.getData()
        } else {
          this.$bus.$emit("alert", { type: "error", message: data.msg });
        }
      });
    },
    getCodeClick() {
      this.$http({
        url: "commonSmsValidCode",
        params: {
          // token: getCookie('admin-token'),
          // source: 'admin-api',
          // 'exchange-client': 'pc-admin',
          //type: this.googleIsOpen === '0' ? 3 : 4
          operateType: this.googleIsOpen === "0" ? 29 : 26,
        },
        // apiType: 'auth'
      }).then(({ code, data, msg }) => {
        if (code.toString() === "0") {
          this.$bus.$emit("alert", {
            type: "success",
            message: this.$t("login.sendCode"),
          });
        } else {
          this.$bus.$emit("getCodeClear");
          this.$bus.$emit("alert", { type: "error", message: msg });
        }
      });
    },
    link(v) {
      window.open(v);
    },
    copy() {
      const input = this.$refs.copyInput;
      input.select();
      document.execCommand("copy");
      // 地址复制成功
      this.$bus.$emit("alert", {
        message: this.$t("header.google.copySuccess"),
        type: "success",
      });
    },
    getData() {
      this.$http({
        url: "bind_google_auth",
      }).then((data) => {
        if (data.code.toString() === "0") {
          const { googleImg, googleKey } = data.data;
          this.googleImg = googleImg;
          this.googleKey = googleKey;
        } else {
          this.$bus.$emit("alert", { type: "error", message: data.msg });
        }
      });
    },
    reset() {
      this.$bus.$emit("getCodeClear");
      this.sms = "";
      this.google = "";
    },
  },
};
</script>


<style lang="scss" scoped>
.bindGoogle {
  width: 100%;
  margin-top: -17px;
  .passwordInput {
    width: 380px !important;
  }
  .setpass-input-box {
    position: relative;
    margin: 0;
    margin-top: 30px;
    // padding-bottom: 20px;
    .invalid-feedback {
      position: absolute;
      bottom: -18px;
    }
    .getCodeInput-get {
      position: absolute;
      right: 10px;
      top: 7px;
      z-index: 2;
      height: 20px;
      min-width: 20px;
    }
  }
  .setpass-input-box :first-child {
    margin-bottom: -10px !important;
  }
}

.bindGoogle-header {
  width: 100%;
  height: 40px;
  background: #f5f8f8;
  border: 1px solid #e5e5e5;
  line-height: 40px;
  font-size: 12px;
  padding-left: 20px;
  box-sizing: border-box;
}
.bindGoogle .even-box {
  width: 100%;
  padding: 40px 0;
  border-bottom: 1px solid #ebebeb;
  &:last-child {
    border-bottom: 1px solid #fff;
    padding: 40px 0 0 0;
  }
}
.bindGoogle .even {
  width: 380px;
  margin: 0 auto;
}
.bindGoogle .even-title {
  font-size: 14px;
  position: relative;
  color: #263954;
}
.bindGoogle .even-title-page {
  position: absolute;
  width: 18px;
  height: 18px;
  background: rgba(9, 91, 232, 0.15);
  font-size: 14px;
  color: #095be8;
  line-height: 18px;
  text-align: center;
  border-radius: 50%;
  left: -25px;
  top: 1px;
}
.bindGoogle .even-text {
  font-size: 12px;
  color: #93979d;
  line-height: 20px;
  margin-top: 15px;
  .even-text-jg {
    position: relative;
    top: -3px;
    margin-right: 7px;
  }
}
.bindGoogle .even-link {
  width: 180px;
  height: 40px;
  background: #095be8;
  text-align: center;
  line-height: 40px;
  color: #fff;
  float: left;
  border-radius: 2px;
  cursor: pointer;
  font-style: normal;
  font-weight: 500;
  font-family: "HarmonyOS-Regular"  !important;
}
.bindGoogle .QAIMG {
  width: 100px;
  height: 100px;
  border: 1px solid #e8eef5;
  display: block;
  float: left;
  box-sizing: border-box;
}
.bindGoogle .QAtext {
  float: left;
  background: #f4f5f5;
  width: 260px;
  height: 30px;
  margin-left: 20px;
  line-height: 30px;
  padding: 0 15px;
  box-sizing: border-box;
  font-size: 14px;
  position: relative;
  overflow: hidden;
}
.QAtext .copyInput {
  position: absolute;
  left: 1000px;
  top: 1000px;
}
.bindGoogle .QAtext-copy {
  position: absolute;
  right: 15px;
  line-height: 30px;
  top: 0;
  cursor: pointer;
  font-size: 12px;
  color: #828ea1;
  user-select: none;
  font-family: "HarmonyOS-Medium" !important;
}
.bindGoogle .even-input-box {
  width: 100%;
  height: 35px;
  border-bottom: 1px solid #d5dee7;
  position: relative;
}
.bindGoogle .getCode {
  position: absolute;
  right: 10px;
  top: 0;
  line-height: 35px;
  cursor: pointer;
  font-size: 12px;
  color: #24a0f5;
  user-select: none;
}
.bindGoogle .even-input {
  width: 100%;
  height: 100%;
  border: none;
}
.even-submit {
  background: #828ea1;
  width: 380px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  color: #fff;
  border-radius: 2px;
  cursor: pointer;
  user-select: none;
}
.can {
  background: #24a0f5 !important;
}
</style>
